import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import { jumpToUser } from 'src/helper/webviewFun'
import lang from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import ReminderBtn from 'src/component/myRuleButton'
import Message from '../../../component/Message'
import http from 'src/helper/http'
import score from 'src/helper/score'
import Swiper from 'swiper'
import 'swiper/swiper-bundle.min.css'
@inject('store')
@observer
export default class Couples extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    lang: lang.en,
    language: 'en',
    minute: 0,
    day: 0,
    hour: 0,
    second: 0,
    gameList: [],
    selectGameId: null,
    rankReward: [],
    topList: [],
    lostList: []
  }

  async componentDidMount() {
    let { language } = this.props.location.query
    const uid = await setUidToken(this.props.location.query)
    language = await getlang(language)
    if (language == 'ar') {
      setDocumentTitle('عيد الفطر')
    } else if (language == 'tr') {
      setDocumentTitle('Ramazan Bayramı')
    } else {
      setDocumentTitle('eid al-fitr')
    }
    this.setState({
      lang: setlang(language, lang),
      language: language,
      uid
    })
    this.getGameListIcon()
    this.getGameReward()
  }

  countDown = (times = 2299085) => {
    let { lang } = this.state
    var timer = null
    timer = setInterval(() => {
      var day = 0,
        hour = 0,
        minute = 0,
        second = 0
      if (times > 0) {
        day = Math.floor(times / (60 * 60 * 24))
        hour = Math.floor(times / (60 * 60)) - day * 24
        minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
        second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
      }
      if (day <= 9) day = day
      if (hour <= 9) hour = '0' + hour
      if (minute <= 9) minute = '0' + minute
      if (second <= 9) second = '0' + second
      let daystr = ''
      if (day > 0) {
        // daystr = day
        daystr = day + ' ' + lang.days
      }
      this.setState({
        minute,
        day,
        hour,
        second
      })
      times--
    }, 1000)
    if (times <= 0) {
      clearInterval(timer)
    }
  }

  getGameListIcon = async() => {
    let res = await http.post('/web/sologame/gamelist')
    if (res.code == 0) {
      this.setState({
        gameList: res.res || [],
        selectGameId: res.res[0] ? res.res[0].id : null
      })
      this.getGameRankingList(1)
    }
  }

  showViewBoxModle = (open, close) => {
    let { lang, rankReward, language } = this.state
    return (
      <div className="eid-activities-modle" >
        <div className='title-tip'>{lang.rewards}</div>
        <div className='' style={{height: '.48rem'}}></div>
        <div className="show-box-body" onClick={() => close()}>
          {Object.keys(rankReward).length > 0 && Object.keys(rankReward).map((item, index) => (
            <div key={index}>
              {index != 3 && <div className='or-tip'>{language == 'tr' ? 'İlk' : 'Top'}{index + 1}</div>}
              <div className='show-box-item'>
                {rankReward[`rankReward${index + 1}`] && rankReward[`rankReward${index + 1}`].length > 0 && rankReward[`rankReward${index + 1}`].map((item, index) => (<div className='reward-item' key={index}>
                  <div className='gift-img'>
                    <img className={`${item.rewardType == 'custom_flash' ? '' : 'gift-img-atr'}`} style={{maxHeight: `${item.rewardType == 'custom_flash' ? '0.91rem' : ''}`}} src={language == 'tr' ? item.picTr || item.pic : language == 'ar' ? item.picAr || item.pic : item.pic}></img>
                    <div className='gift-time'>{language == 'ar' ? item.rewardNum + 'يوم' : language == 'tr' ? item.rewardNum + 'Gün' : item.rewardNum + 'day'}</div>
                  </div>
                  <div className='gift-name'>{language == 'tr' ? item.rewardNameTr || item.rewardName : language == 'ar' ? item.rewardNameAr || item.rewardName : item.rewardName}</div>
                </div>))}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  selectGmaeItem= (id) => {
    this.setState({selectGameId: id})
    this.getGameRankingList(id)
  }

  getGameReward = async() => {
    let res = await http.post('/web/sologame/rewardlist')
    if (res.code == 0) {
      this.setState({ rankReward: res.res })
    }
    console.log(res)
  }

  getGameRankingList = async(id) => {
    let res = await http.post('/web/sologame/ranklist', {gameId: id})
    console.log(res)
    if (res.code == 0) {
      let topList = res.res.list && res.res.list.length > 0 ? res.res.list.slice(0, 4) : []
      let lostList = res.res.list && res.res.list.length >= 4 ? res.res.list.slice(3, res.res.list.length + 1) : []
      this.setState({ gameRankList: res.res.list || [], topList, lostList })
    }
  }

  computName =(value, key) => {
    if (key == 'img') {
      return value && value.avatarurl ? value.avatarurl : 'https://img.chatie.live/app/man.jpg'
    } else if (key == 'name') {
      return value && value.nickname ? value.nickname : 'Yayya'
    } else if (key == 'id') {
      return value && value.duid ? value.duid : 'Yayya'
    }
  }

  jupFn =(value) => {
    value && value.uid && jumpToUser(value.uid)
  }

  render() {
    let { language, lang, day, hour, second, minute, gameList, selectGameId, gameRankList, topList, lostList } = this.state
    console.log('---oop---', topList, lostList)
    return (
      <div className={`all-gamrank ${language == 'ar' ? 'arlang' : ''}`} >
        <div className={`game-icon-list ${language == 'ar' ? 'isar' : 'noar'}`}>
          {gameList.length > 0 && gameList.map((item, index) => (<img style={{marginLeft: `${language == 'ar' ? '0.16rem' : ''}`, marginRight: `${language == 'ar' ? '' : '0.16rem'}`}} className={selectGameId == item.id ? '' : 'noindex'} key={index} src={item.squareImage} onClick={() => this.selectGmaeItem(item.id)}></img>)) }
        </div>
        <div className='raknging-top'>
          <ReminderBtn
            lang={lang}
            slotButtonComp={() => {
              return <div className="allgameReward-rules"></div>
            }}
            slotContentComp={this.showViewBoxModle}
          />
          <div className='top-one-root'>
            <div className='haerd-user' onClick={() => this.jupFn(topList[0])}>
              <img className='bg-goorb' src='/img/activity/allgameRank/img_rank_head_top1.png'></img>
              <img className='user-img' src={this.computName(topList[0], 'img')}></img>
            </div>
            <div className='info-bg'>
              <div className='name'>{this.computName(topList[0], 'name')}</div>
              <div className='info-id'>ID {this.computName(topList[0], 'id')}</div>
            </div>
          </div>
          <div className='top-three-root'>
            <div className='haerd-user' onClick={() => this.jupFn(topList[1])}>
              <img className='bg-goorb' src='/img/activity/allgameRank/img_rank_head_top2.png'></img>
              <img className='user-img' src={this.computName(topList[1], 'img')}></img>
            </div>
            <div className='info-bg'>
              <div className='name'>{this.computName(topList[1], 'name')}</div>
              <div className='info-id'>ID {this.computName(topList[1], 'id')}</div>
            </div>
          </div>
          <div className='top-two-root'>
            <div className='haerd-user' onClick={() => this.jupFn(topList[2])}>
              <img className='bg-goorb' src='/img/activity/allgameRank/img_rank_head_top3.png'></img>
              <img className='user-img' src={this.computName(topList[2], 'img')}></img>
            </div>
            <div className='info-bg'>
              <div className='name'>{this.computName(topList[2], 'name')}</div>
              <div className='info-id'>ID {this.computName(topList[2], 'id')}</div>
            </div>
          </div>
        </div>
        <div className='lost-rakngingtop-inallgame'>
          {lostList.length > 0 && lostList.map((item, index) => (<div className='item' key={index}>
            <div className='item-left-allgame'>
              <div className='top-num'>{item.rankIdx}</div>
              <div className='top-user-info'>
                <img src={item.avatarurl} onClick={() => jumpToUser(item.uid)}></img>
                <div className='info'>
                  <div className='info-name'>{item.nickname}</div>
                  <div className='info-uid'>ID {item.duid}</div>
                </div>
              </div>
            </div>
            <div className='item-right-allgame'>{score(item.score)}</div>
          </div>))}
        </div>
        <Message ref="msg" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/allGamRank/index.js